import _capitalize from 'lodash/capitalize';

export const getTrackData = (metadata) => {
  return {
    firstArtist: metadata?.artists?.[0]?.name,
    preview: metadata?.external_metadata?.spotify?.[0]?.preview,
    albumCover: metadata?.album?.cover,
    largeAlbumCover: metadata?.album?.covers?.large,
    mediumAlbumCover: metadata?.album?.covers?.medium,
    smallAlbumCover: metadata?.album?.covers?.small,
    albumName: metadata?.album?.name,
  };
};

const sabcColors = ['#F3EB4C', '#42B549', '#3B5FAA', '#EE3124', 'black'];
const sabcDarkColors = ['#FDB913', '#009247', '#263B80', '#A51E22', 'black'];

export const normaliseTop5LabelData = (resData) => {
  const ret = [['Label', 'Play Duration', { role: 'style' }]];

  for (let i = 0, count = 0; i < resData.length; i++) {
    const val = resData[i];

    if (!val.label) continue;

    if (count === 5) break;

    ret.push([val.label, +val.play_duration, sabcColors[count]]);

    count++;
  }
  return ret;
};

export const normaliseTop5ArtistData = (resData) => {
  const ret = [['Artist', 'Play Duration', { role: 'style' }]];

  for (let i = 0, count = 0; i < resData.length; i++) {
    const val = resData[i];

    if (count === 5) break;

    if (!val.artist) continue;

    ret.push([val.artist, +val.play_duration, sabcColors[count]]);

    count++;
  }
  return ret;
};

export const getCurrentMonthNum = () => new Date().getMonth() + 1;

export const elipsify = (str, maxLength = 30) => {
  str = str || '-';
  return str?.substring(0, maxLength) + (str?.length > maxLength ? '...' : '');
};

export const extractChannelLogos = (res) => {
  const ret = {};
  res?.data?.map((item) => {
    ret[item.name] = item.logo;
  });
  return ret;
};

export const monthsOfTheYear = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function getMonth(number) {
  if (typeof number === 'string') return number;
  const months = ['', ...monthsOfTheYear];
  return months[number];
}

export const normalizePieChartData = (
  resData,
  heading = ['Category', 'Count'],
) => {
  const ret = [heading];
  for (let k in resData) {
    ret.push([_capitalize(k), resData[k]]);
  }
  return ret;
};
